import React from "react";
import { css, keyframes } from "goober";

import BlitzLogoLoadingIcon from "@/inline-assets/blitz-logo-loading.svg";

const LOADING_ELEMENT_CSS_ANIMATION = () => keyframes`
  0%,
  5% {
    stroke-dasharray: 0, 0, 0, 90, 0, 95;
    stroke-dashoffset: 45;
  }

  40% {
    stroke-dashoffset: 5;
  }

  40%,
  60% {
    stroke-dasharray: 0, 0, 90, 0, 95, 0;
  }

  60% {
    stroke-dashoffset: -40;
  }

  95%,
  100% {
    stroke-dasharray: 0, 90, 0, 95, 0, 0;
    stroke-dashoffset: -85;
  }
`;

const cssBlitzLoading = () => css`
  width: var(--blitz-loading-size);
  height: var(--blitz-loading-size);

  overflow: visible;

  & > path {
    fill: transparent;
  }

  & > path:nth-child(2) {
    stroke: var(--c);
    stroke-width: 4px;

    animation-name: ${LOADING_ELEMENT_CSS_ANIMATION()};
    animation-duration: var(--blitz-loading-loop);
    animation-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
    animation-fill-mode: backwards;
    animation-iteration-count: infinite;
  }
`;

export default function BlitzLogoLoading({
  color = "var(--shade3-50)",
}: {
  color?: string;
}) {
  return (
    <BlitzLogoLoadingIcon
      className={cssBlitzLoading()}
      style={{ "--c": color }}
    />
  );
}
